module.exports = __webpack_public_path__ + "images/lp-sl-m-jeff-li-1.webp";